module.exports = __webpack_public_path__ + "static/media/sell_help_12.d52d71ac.png";